/**
 * The laboratory order workflow (spec §12), shared by the server and the
 * Windows application so an order moved offline follows the same steps.
 */
export const LAB_ORDER_STATES = [
  'draft',
  'awaiting_pickup',
  'collected',
  'in_preparation',
  'ready',
  'received',
  'fitting',
  'adjustment_requested',
  'returned_for_adjustment',
  'completed',
  'cancelled',
] as const;
export type LabOrderState = (typeof LAB_ORDER_STATES)[number];

export const LAB_ORDER_TRANSITIONS: Record<LabOrderState, LabOrderState[]> = {
  draft: ['awaiting_pickup', 'cancelled'],
  awaiting_pickup: ['collected', 'cancelled'],
  collected: ['in_preparation', 'cancelled'],
  in_preparation: ['ready', 'cancelled'],
  ready: ['received', 'cancelled'],
  received: ['fitting', 'adjustment_requested', 'completed'],
  fitting: ['completed', 'adjustment_requested'],
  adjustment_requested: ['returned_for_adjustment'],
  returned_for_adjustment: ['in_preparation', 'ready'],
  completed: [],
  cancelled: [],
};

/** The states in which the laboratory has handed the work over and is owed for it. */
export const LAB_RECEIVED_STATES: ReadonlySet<LabOrderState> = new Set<LabOrderState>([
  'received',
  'fitting',
  'adjustment_requested',
  'returned_for_adjustment',
  'completed',
]);
